import type { Routes } from '@angular/router';
import {
    PageContentType,
    WarrantyPageFeature,
    createActionTriggerDealer,
    createMetaResolverWithDealer,
    defaultTitleResolver,
    ngrxLoaderGuard,
} from '@hyundai/ng-common-lib';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { WarrantyPageComponent } from './warranty-page.component';

export default [
    {
        path: '',
        component: WarrantyPageComponent,
        canActivate: [
            ngrxLoaderGuard({
                waitUntilLoadedSelector: WarrantyPageFeature.state.selectIsLoadingWarranty,
                dataToCheckSelector: WarrantyPageFeature.state.selectContent,
            }),
        ],
        providers: [
            provideState(WarrantyPageFeature.state),
            provideEffects([WarrantyPageFeature.warrantyEffects]),
            createActionTriggerDealer(WarrantyPageFeature.actions.loadPageWarranty()),
        ],
        title: defaultTitleResolver('Garantien'),
        resolve: {
            meta: createMetaResolverWithDealer((dealer) => {
                return {
                    description: `Profitieren Sie von 5 Jahren serienmäßiger Hyundai Fahrzeuggarantie bei ${dealer.name} in ${dealer.city}.`,
                };
            }),
        },
        data: {
            contentType: PageContentType.WARRENTY,
        },
    },
] satisfies Routes;
